import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * 総合判定
 */
export default class Shishiki extends BaseEnum{
    static INTERNAL_CODE_49 = {value: '1', name: 'C1'} as Enum
    static INTERNAL_CODE_50 = {value: '2', name: 'C2'} as Enum
    static INTERNAL_CODE_51 = {value: '3', name: 'C3'} as Enum
    static INTERNAL_CODE_52 = {value: '4', name: 'C4'} as Enum
    static INTERNAL_CODE_53 = {value: '5', name: 'IIC'} as Enum
    static INTERNAL_CODE_66 = {value: 'B', name: 'RFIIC'} as Enum
    static INTERNAL_CODE_67 = {value: 'C', name: 'AFIIC'} as Enum
    static INTERNAL_CODE_69 = {value: 'E', name: 'InIIC'} as Enum
    static INTERNAL_CODE_70 = {value: 'F', name: 'OnIIC'} as Enum
    static INTERNAL_CODE_76 = {value: 'L', name: 'CrIIC'} as Enum
    static INTERNAL_CODE_71 = {value: 'G', name: 'MBIIC'} as Enum
    static INTERNAL_CODE_72 = {value: 'H', name: 'JcIIC'} as Enum
    static INTERNAL_CODE_73 = {value: 'I', name: 'VcIIC'} as Enum
    static INTERNAL_CODE_74 = {value: 'J', name: 'PoIIC'} as Enum
    static INTERNAL_CODE_75 = {value: 'K', name: 'BrIIC'} as Enum
    static INTERNAL_CODE_68 = {value: 'D', name: 'CeIIC'} as Enum
    static INTERNAL_CODE_77 = {value: 'M', name: '脱落'} as Enum
    static INTERNAL_CODE_41 = {value: ')', name: 'Ｘ'} as Enum
    static INTERNAL_CODE_125 = {value: '}', name: 'ﾀﾞﾐｰ'} as Enum
    static INTERNAL_CODE_34 = {value: '"', name: 'PD'} as Enum
    static INTERNAL_CODE_35 = {value: '#', name: 'FD'} as Enum
    static INTERNAL_CODE_83 = {value: 'S', name: ''} as Enum
    static INTERNAL_CODE_115 = {value: 's', name: ''} as Enum
    static INTERNAL_CODE_45 = {value: '-', name: 'RF'} as Enum
    static INTERNAL_CODE_55 = {value: '7', name: 'AF'} as Enum
    static INTERNAL_CODE_56 = {value: '8', name: 'In'} as Enum
    static INTERNAL_CODE_65 = {value: 'A', name: 'On'} as Enum
    static INTERNAL_CODE_57 = {value: '9', name: 'Cr'} as Enum
    static INTERNAL_CODE_61 = {value: '=', name: 'MB'} as Enum
    static INTERNAL_CODE_92 = {value: '\\', name: 'Jcr'} as Enum
    static INTERNAL_CODE_33 = {value: '!', name: 'Vcr'} as Enum
    static INTERNAL_CODE_94 = {value: '^', name: 'Post'} as Enum
    static INTERNAL_CODE_37 = {value: '%', name: 'Tr'} as Enum
    static INTERNAL_CODE_36 = {value: '$', name: 'Ce'} as Enum
    static INTERNAL_CODE_48 = {value: '0', name: 'Br'} as Enum
    static INTERNAL_CODE_88 = {value: 'X', name: '*'} as Enum
    static INTERNAL_CODE_120 = {value: 'x', name: '#'} as Enum
    static INTERNAL_CODE_59 = {value: ';', name: 'Co'} as Enum
    static INTERNAL_CODE_78 = {value: 'N', name: '破折'} as Enum
    static INTERNAL_CODE_38 = {value: '&', name: 'ｍ'} as Enum
    static INTERNAL_CODE_126 = {value: '~', name: ''} as Enum
    static INTERNAL_CODE_54 = {value: '6', name: 'WSD'} as Enum
    static INTERNAL_CODE_97 = {value: 'a', name: '乳A'} as Enum
    static INTERNAL_CODE_98 = {value: 'b', name: '乳B'} as Enum
    static INTERNAL_CODE_99 = {value: 'c', name: '乳C'} as Enum
    static INTERNAL_CODE_100 = {value: 'd', name: '乳D'} as Enum
    static INTERNAL_CODE_101 = {value: 'e', name: '乳E'} as Enum
    static INTERNAL_CODE_124 = {value: '|', name: '乳'} as Enum
}
Shishiki.values = [Shishiki.INTERNAL_CODE_49, Shishiki.INTERNAL_CODE_50, Shishiki.INTERNAL_CODE_51, Shishiki.INTERNAL_CODE_52, Shishiki.INTERNAL_CODE_53, Shishiki.INTERNAL_CODE_66, Shishiki.INTERNAL_CODE_67, Shishiki.INTERNAL_CODE_69, Shishiki.INTERNAL_CODE_70, Shishiki.INTERNAL_CODE_76, Shishiki.INTERNAL_CODE_71, Shishiki.INTERNAL_CODE_72, Shishiki.INTERNAL_CODE_73, Shishiki.INTERNAL_CODE_74, Shishiki.INTERNAL_CODE_75, Shishiki.INTERNAL_CODE_68, Shishiki.INTERNAL_CODE_77, Shishiki.INTERNAL_CODE_41, Shishiki.INTERNAL_CODE_125, Shishiki.INTERNAL_CODE_34, Shishiki.INTERNAL_CODE_35, Shishiki.INTERNAL_CODE_83, Shishiki.INTERNAL_CODE_115, Shishiki.INTERNAL_CODE_45, Shishiki.INTERNAL_CODE_55, Shishiki.INTERNAL_CODE_56, Shishiki.INTERNAL_CODE_65, Shishiki.INTERNAL_CODE_57, Shishiki.INTERNAL_CODE_61, Shishiki.INTERNAL_CODE_92, Shishiki.INTERNAL_CODE_33, Shishiki.INTERNAL_CODE_94, Shishiki.INTERNAL_CODE_37, Shishiki.INTERNAL_CODE_36, Shishiki.INTERNAL_CODE_48, Shishiki.INTERNAL_CODE_88, Shishiki.INTERNAL_CODE_120, Shishiki.INTERNAL_CODE_59, Shishiki.INTERNAL_CODE_78, Shishiki.INTERNAL_CODE_38, Shishiki.INTERNAL_CODE_126, Shishiki.INTERNAL_CODE_54, Shishiki.INTERNAL_CODE_97, Shishiki.INTERNAL_CODE_98, Shishiki.INTERNAL_CODE_99, Shishiki.INTERNAL_CODE_100, Shishiki.INTERNAL_CODE_101, Shishiki.INTERNAL_CODE_124]
